import {
  addInfoTypeApi,
  deleteInfoTypeApi,
  updateInfoTypeApi,
  getInfoTypeByIdApi,
  queryInfoTypeApi,
  batchSetInfoTypeSortNumApi,
  getInfoReleaseByIdApi,
  queryInfoReleaseApi,
  setInfoReleaseMsgApi,
  queryReleaseEvaluateApi,
  queryWechatNoticeBindApi,
  addWechatNoticeBindForBrandApi,
  setFormTableMsgApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  添加信息类型
  async addInfoTypeAction(context, param) {
    const res = await addInfoTypeApi(param)
    return res
  },
  //  删除信息类型
  async deleteInfoTypeAction(context, param) {
    const res = await deleteInfoTypeApi(param)
    return res
  },
  //  更新信息类型
  async updateInfoTypeAction(context, param) {
    const res = await updateInfoTypeApi(param)
    return res
  },
  //  根据id获取信息类型
  async getInfoTypeByIdAction(context, param) {
    const res = await getInfoTypeByIdApi(param)
    return res
  },
  //  查询信息类型
  async queryInfoTypeAction(context, param) {
    const res = await queryInfoTypeApi(param)
    return res
  },
  //  批量设置信息类型排序号
  async batchSetInfoTypeSortNumAction(context, param) {
    const res = await batchSetInfoTypeSortNumApi(param)
    return res
  },
  //  根据id获取信息发布
  async getInfoReleaseByIdAction(context, param) {
    const res = await getInfoReleaseByIdApi(param)
    return res
  },
  //  查询信息发布
  async queryInfoReleaseAction(context, param) {
    const res = await queryInfoReleaseApi(param)
    return res
  },
  //  设置信息发布信息
  async setInfoReleaseMsgAction(context, param) {
    const res = await setInfoReleaseMsgApi(param)
    return res
  },
  //  查询信息发布评论
  async queryReleaseEvaluateAction(context, param) {
    const res = await queryReleaseEvaluateApi(param)
    return res
  },
  //  查询微信通知绑定列表信息
  async queryWechatNoticeBindAction(context, param) {
    const res = await queryWechatNoticeBindApi(param)
    return res
  },
  //  添加微信通知绑定(用于品牌)
  async addWechatNoticeBindForBrandAction(context, param) {
    const res = await addWechatNoticeBindForBrandApi(param)
    return res
  },
  //  设置自定义表单信息
  async setFormTableMsgAction(context, param) {
    const res = await setFormTableMsgApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
